import ministryService from "../../services";
import FAQ from "./settings-pages/faq/store";
import FAQCategories from "./settings-pages/faq-categories/store";
import Indexes from "./settings-pages/indexes/store";
import Events from "./settings-pages/events/store";
import Instructions from "./settings-pages/instructions/store";
import Regulations from "./settings-pages/regulations/store";
import Roles from "./settings-pages/roles/store";
import UsersAvailability from "./settings-pages/users-availability/store";
import ImageSlider from "./settings-pages/image-slider/store";
import NgosManagement from "./settings-pages/ngos-management/store";
import NgosValidation from "./settings-pages/ngos-validation/store";
import ShamlForms from "./settings-pages/shaml-forms/store";
import MediationRequestes from "./settings-pages/mediation-requestes/store";
import TransactionManagement from "./settings-pages/transaction-management/store";
import Transaction from "./settings-pages/accreditation-transactions/store";
import Holidays from "./settings-pages/holidays/store";

export default {
  namespaced: true,
  modules: {
    FAQ,
    FAQCategories,
    Indexes,
    ImageSlider,
    Roles,
    UsersAvailability ,
    Instructions,
    Regulations,
    Events,
    NgosManagement,
    NgosValidation,
    ShamlForms,
    MediationRequestes,
    Transaction,
    Holidays ,
    TransactionManagement
  },
  state: () => {
    return {
      dataObj: {},
      loading: false,
    };
  },
  getters: {
    dataObj(state) {
      return state.dataObj;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setData(state, payload) {
      state.dataObj = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    async fetchRecordData({ commit }, params) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchReportRecord(params);
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
